import { Enums } from '@bode-canada/core';

export const CALLBACK_BOOK_VIEWING_IDENTIFIER = 'draft-book-viewing';
export const TYPICAL_BUY_COMMISSIONS_AB = {
  firstPartOfSalePriceCommission: 3.5,
  balanceSalePriceCommission: 1.5,
};
export const TYPICAL_BUY_COMMISSIONS_BC = {
  firstPartOfSalePriceCommission: 7.0,
  balanceSalePriceCommission: 2.5,
};
export const TYPICAL_BUY_COMMISSIONS_ON = {
  firstPartOfSalePriceCommission: 2.5,
  balanceSalePriceCommission: 2.5,
};

export const TOOL_TIPS_TEXT = {
  BUY_SIDE_COMMISSION: 'Bōde advertising approach finds buyers who are not working with agents. If you offer a buy-side commission but ultimately sell to a buyer with no agent, you never have to pay out this amount',
  TYPICAL_COMMISSION: 'While the Competition Act prevents any price-setting and there is no set standard, there are typical commissions offered on a provincial basis. If you choose to offer a commission this information will only be available to licenced real estate associates. Regulations outline that commissions may only be paid to real estate professionals licenced under The Real Estate Act. ',
};

export const CALGARY_LOCATION = {
  lat: '51.0447',
  lng: '-114.0719',
};

export const GEO_LOCATION_URL = 'https://ipapi.co/json/';

export const LISTING_ORIGIN_TYPES = {
  Bode: 'Bode',
  Repliers: 'Repliers_REBGV',
  Bridge: 'Bridge_CREB',
  BridgeRAE: 'Bridge_RAE',
  DDF: 'DDF_AB',
  bode: 'Bode',
  repliers: 'Repliers_REBGV',
  bridge: 'Bridge_CREB',
  bridgeRAE: 'Bridge_RAE',
  ddf: 'DDF_AB',
};

export const LISTING_TRACK_EVENT_ORIGIN_TYPES = {
  Bode: 'Bode',
  Repliers: 'MLS',
  Bridge: 'MLS',
  BridgeRAE: 'MLS',
  DDF: 'MLS',
  MLS: 'MLS',
};

export const PROVINCES = {
  [Enums.ProvinceEnum.AB]: Enums.ProvinceEnum.AB,
  [Enums.ProvinceEnum.BC]: Enums.ProvinceEnum.BC,
  [Enums.ProvinceEnum.ON]: Enums.ProvinceEnum.ON,
};

export const DIRECTIONS = {
  East: 'East',
  North: 'North',
  West: 'West',
  South: 'South',
  Northeast: 'Northeast',
  Northwest: 'Northwest',
  Southeast: 'Southeast',
  Southwest: 'Southwest',
};

export const DIRECTIONS_OPTIONS = [
  { label: DIRECTIONS.East, value: DIRECTIONS.East },
  { label: DIRECTIONS.North, value: DIRECTIONS.North },
  { label: DIRECTIONS.West, value: DIRECTIONS.West },
  { label: DIRECTIONS.South, value: DIRECTIONS.South },
  { label: DIRECTIONS.Northeast, value: DIRECTIONS.Northeast },
  { label: DIRECTIONS.Northwest, value: DIRECTIONS.Northwest },
  { label: DIRECTIONS.Southeast, value: DIRECTIONS.Southeast },
  { label: DIRECTIONS.Southwest, value: DIRECTIONS.Southwest },
];

// todo: change text to label when we stop use old select field
// todo: change province select component to this enum when all ontario
// implementations finished
export const PROVINCE_OPTIONS = [
  { text: 'Alberta', value: PROVINCES.AB },
  { text: 'British Columbia', value: PROVINCES.BC },
  { text: 'Ontario', value: PROVINCES.ON },
];

// todo: Remove this from the store province select and replace with PROVINCE_OPTIONS
// seen above once all pages are correctly implemented (Ontario can break un-implemented pages)
export const PROVINCE_OPTIONS_NOT_ONTARIO = [
  { text: 'Alberta', value: PROVINCES.AB },
  { text: 'British Columbia', value: PROVINCES.BC },
];

export const PROVINCE_OPTIONS_WITH_SHORT_LABEL = [
  { label: PROVINCES.AB, value: PROVINCES.AB },
  { label: PROVINCES.BC, value: PROVINCES.BC },
  { label: PROVINCES.ON, value: PROVINCES.ON },
];
